// 应用
import http from "../../utils/http";
import * as TYPES from '../../store/app/action-types';
import {ls} from '../../store/local-store';
import cities from './cities';
import { isMiniprogram } from "../../utils";
import { MpUtil, CITY_PAY_URL_MAP } from "../../utils/MpUtil";

export function AppService(context) {
	const dispatch = context.$store.dispatch;
	const APP__SET_CITY_ID_ACTION = TYPES.APP__SET_CITY_ID;
	const APP__SET_CITY_NAME_ACTION = TYPES.APP__SET_CITY_NAME;
	const APP__SET_WX_PAY_INFO_ACTION = TYPES.APP__SET_WX_PAY_INFO;
	const APP__SET_TICKET_INFO_ID_ACTION = TYPES.APP_SET_TICKET_INFO_ID;
	function _getCityNameById(id) {
		return cities[id];
	}
	function getCityId() {
		return context.$store.state.app.cityId;
	}
	function getCityName() {
		return context.$store.state.app.cityName;
	}
	function getWxPayInfo() {
		return context.$store.state.app.wxPayInfo;
	}
	function setTicketInfoId(id) {
		dispatch(APP__SET_TICKET_INFO_ID_ACTION, id);
	}
	function getTicketInfoId() {
		return context.$store.state.app.ticketInfoId;
	}
	function fetchWxPayInfo(ticketInfoId) {
		return http.get(`/order/sendOrderTicketInfo?ticketInfoId=${ticketInfoId}`);
	}
	function isTestMobile() {
		let userMobile = context.$UserService.getUserMobile();
		return ['18101089825', '15320099550', '18578275948', '13453018433', '18210191658', '17322748957', '17322743607'].indexOf(userMobile) !== -1;
	}
	return {
		/**
		 * 下单
		 * @param params
		 * @return {Promise<string|*>}
		 */
		order(params) {
			return new Promise((resolve, reject) => {
				http.post('/order/orderTicket', params).then((data) => {
					const {id: ticketInfoId} = data || {};
					setTicketInfoId(ticketInfoId);
          if (params.actualPrice > 0 && !isMiniprogram()) {
            return fetchWxPayInfo(ticketInfoId);
          }
				}).then((res) => {
					console.log('==', res);
					resolve(res);
				}).catch(res => {
					reject(res);
				});
			});
		},
    // 补票
    supplyOrder(params) {
      return http.post('/order/supplyOrderTicket', params).then(data => {
        const { id: ticketInfoId } = data || {}
        setTicketInfoId(ticketInfoId)
        if (params.actualPrice > 0 && !isMiniprogram()) {
          return fetchWxPayInfo(ticketInfoId);
        }
      })
    },
		/**
		 * 根据ticketInfoId获取微信支付的字符串
		 * @param {string|number} ticketInfoId
		 */
		fetchWxPayInfo,
		/**
		 * 发起支付
		 * @param info
		 * @return {Promise<unknown>}
		 */
		pay(info) {
			return new Promise((resolve, reject) => {
				function onBridgeReady() {
					window.WeixinJSBridge.invoke("getBrandWCPayRequest", { ...info }, res => {
						return resolve(res);
					});
					return reject();
				}

				if (typeof window.WeixinJSBridge === "undefined") {
					if (document.addEventListener) {
						document.addEventListener("WeixinJSBridgeReady", onBridgeReady, false);
					} else if (document.attachEvent) {
						document.attachEvent("WeixinJSBridgeReady", onBridgeReady);
						document.attachEvent("onWeixinJSBridgeReady", onBridgeReady);
					}
				} else {
					onBridgeReady();
				}
			});
		},
    alipay(info) {
      return new Promise(resolve => {
        function ready(callback) {
          // 如果jsbridge已经注入则直接调用
          if (window.AlipayJSBridge) {
            callback && callback()
          } else {
            document.addEventListener('AlipayJSBridgeReady', callback, false)
          }
        }

        ready(() => {
          localStorage.setItem('__alipayinfo__', info)
          window.AlipayJSBridge.call('pushWindow', {
            url: `${window.location.origin}${window.location.pathname}/#/alipay?cityId=${getCityId()}`,
            param: {
              readTitle: true
            }
          })
          resolve()
        })
      })
    },
		/**
		 * 小程序支付
		 * info: JSON.stringify({订单编号})
		 */
		mppay(info) {
			const { orderId } = info || {}
			const obj = { orderId }
			const params = { 
				orderParams: encodeURIComponent(JSON.stringify(obj)),
			 }
			const cityId = getCityId() || ls.getItem('cityId');
			console.log('小程序支付的cityId是:', cityId);
			let url = ''
			if (CITY_PAY_URL_MAP[cityId]) {
				// 第三方小程序支付页
				url = MpUtil.getThirdPartyUrl(cityId, params)
			} else {
				// 我们自己的小程序支付页
				// url = MpUtil.getThirdPartyUrl('521', params)
				url = MpUtil.getUrl('pay_response', params)
			}
			console.log('小程序支付的url是:', url)
			// console.log('测试第三方支付url获取', MpUtil.getThirdPartyUrl('046', params))
			MpUtil.navigateTo(url)
		},
		/**
		 * 快钱支付
		 * */
		kqPay(info) {
			console.log('快钱支付', info);
			setTimeout(() => {
				window.location.href = info;
			}, 500);
		},
		/**
		 * 设置城市ID
		 * @param id
		 */
		setCityId(id) {
			if (id) {
				ls.setItem('cityId', id);
				dispatch(APP__SET_CITY_ID_ACTION, id);
			}
		},
		/**
		 * 从本地数据中恢复城市ID
		 */
		recoverCityId() {
			let id = ls.getItem('cityId');
			if (id) {
				dispatch(APP__SET_CITY_ID_ACTION, id);
			}
		},
		/**
		 * 设置城市名称
		 * @param name
		 */
		setCityName(name) {
			dispatch(APP__SET_CITY_NAME_ACTION, name);
		},
		/**
		 * 根据城市ID返回城市名
		 * @param id
		 * @return {*}
		 */
		getCityNameById(id) {
			return _getCityNameById(id);
		},
		/**
		 * 获取城市ID
		 * @return {string}
		 */
		getCityId,
		/**
		 * 获取城市名称
		 * @return {string}
		 */
		getCityName,
		/**
		 * 设置微信支付信息
		 * @param {string} info - 微信下单返回的字符串
		 */
		setWxPayInfo(info) {
			console.log('设置微信支付信息', info);
			dispatch(APP__SET_WX_PAY_INFO_ACTION, info);
		},
		/**
		 * 获取微信支付信息字符串
		 */
		getWxPayInfo,
		/**
		 * 设置ticketInfoId
		 * @param id
		 */
		setTicketInfoId,
		/**
		 * 获取ticketInfoId
		 */
		getTicketInfoId,
		isTestMobile,
		/**
		 * 开启开发工具
		 */
		devTools: () => {
			let inAllowedList = isTestMobile() || process.env.NODE_ENV === 'development'
			if (inAllowedList) {
				let id = 'vConsole-script';
				let script = document.querySelector(`#${id}`);
				if (!script) {
					script = document.createElement('script');
					script.id = id;
					script.src = '//dev.maas.chelaile.net.cn/maas-common/vconsole.min.js';
					document.body.appendChild(script);
					script.onload = function() {
						if (VConsole) {
							new VConsole();
						}
					}
				}
			}
		},
		/**
		 * 获取公告
		 */
		getNoticeByAreaName(areaName) {
			areaName = areaName || '';
			console.log(areaName);
			// @脆桃 20210527 网约巴士公告：
			// 佛山新城：维持不变
			// 绿岛湖：网约巴士6月1日正式开通！试运营优惠价1元/人次
			// 千灯湖：网约巴士6月1日正式开通！试运营优惠价1元/人次
			// 西江新城：网约巴士6月1日正式开通！试运营优惠价1元/人次
			// if (areaName.includes('绿岛湖')) {
			// 	return '网约巴士6月1日正式开通！试运营优惠价1元/人次';
			// } else if (areaName.includes('千灯湖')) {
			// 	return '网约巴士6月1日正式开通！试运营优惠价1元/人次';
			// } else if (areaName.includes('西江新城')) {
			// 	return '网约巴士6月1日正式开通！试运营优惠价1元/人次';
			// } else {
			// 	return '4月1日起，网约巴士活动票价调整为2元/人次。小孩与成人同价。';
			// }
      if (areaName.includes('乐平工业园')) {
        return '新开通"合鑫包装“的停靠站点'
      }
      if (areaName.includes('佛山新城')) {
        return '本车可达新妇幼保健院、地铁站、图书馆、游船码头！'
      }
      if (areaName.includes('西江新城')) {
        return '本车可达人民医院、新亨广场、万方智慧城、德恒箐英学校！'
      }
      if (areaName.includes('绿岛湖')) {
        return '本车可达地铁站、公交枢纽站、绿岛广场、永利达广场'
      }
      if (areaName.includes('湖涌')) {
        return '本车可达紫南村史馆、紫南旅游文化中心、洛神民宿'
      }
      if (areaName.includes('千灯湖')) {
        return '本车可达地铁站、保利水城、万达广场！'
      }

      return null
		}
	};
}
export function install(Vue, context) {
	Vue.prototype.$AppService = AppService(context);
}
